import { Box, InfoIcon, Text } from "@wix/design-system";
import React, { useContext } from "react";
import { RicosContext, ZIndexContext } from "./../../../ricos-context";
import { usePanelContainerElement } from "./../../../ui-components";
import { HtmlInputArea } from "./HtmlInputArea";
const AdsenseSourceInput = ({
  htmlNodeAttrs,
  onHtmlInputChange
}) => {
  const { t } = useContext(RicosContext);
  const zIndexService = useContext(ZIndexContext);
  const containerEl = usePanelContainerElement();
  return /* @__PURE__ */ React.createElement(Box, { direction: "vertical", gap: "SP3" }, /* @__PURE__ */ React.createElement(Box, { verticalAlign: "middle", gap: "SP1" }, /* @__PURE__ */ React.createElement(Text, { size: "small" }, t("HtmlEditPanel_HtmlInput_AdSense_Title"), " "), /* @__PURE__ */ React.createElement(
    InfoIcon,
    {
      size: "small",
      content: t("HtmlEditPanel_HtmlInput_AdSense_Tooltip"),
      tooltipProps: {
        appendTo: containerEl,
        zIndex: zIndexService.getZIndex("TOOLTIP")
      }
    }
  )), /* @__PURE__ */ React.createElement(
    HtmlInputArea,
    {
      value: htmlNodeAttrs?.html ?? "",
      onChange: (value) => {
        onHtmlInputChange?.(value);
      },
      placeholder: t("HtmlEditPanel_HtmlInput_AdSense_Placeholder")
    }
  ));
};
export {
  AdsenseSourceInput
};
//# sourceMappingURL=AdsenseSourceInput.js.map
